import { noop } from 'lodash';
export const makeMockIntercomClient = () => ({
  boot: noop,
  shutdown: noop,
  showNewMessage: noop,
  update: noop,
  hideIntercom: noop,
  showIntercom: noop,
  onLoadFailed: noop,
  isLoaded: () => false
});
export const makeMockIntercomClientWithJest = function makeMockIntercomClientWithJest() {
  let {
    isLoaded = () => false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    boot: jest.fn(),
    shutdown: jest.fn(),
    showNewMessage: jest.fn(),
    update: jest.fn(),
    hideIntercom: jest.fn(),
    showIntercom: jest.fn(),
    onLoadFailed: jest.fn(),
    isLoaded: isLoaded
  };
};